<template>
    <UModal :model-value="modelValue" @update:model-value="$emit('update:modelValue', $event)">
        <UCard>
            <template #header>
                <div class="flex items-center justify-between">
                    <h3 class="text-lg font-semibold">Accept Transport</h3>
                    <UButton icon="i-ph-x" variant="ghost" color="gray" @click="$emit('update:modelValue', false)" />
                </div>
            </template>

            <div class="space-y-4">
                <p class="text-sm text-gray-500">
                    Confirm you can take this transport. You can set the final price when you complete it.
                </p>
                <UFormGroup label="Remarks">
                    <UTextarea v-model="remarks" placeholder="Optional remarks..." size="xl" />
                </UFormGroup>
            </div>

            <template #footer>
                <div class="flex gap-3 justify-end">
                    <UButton color="gray" variant="ghost" @click="$emit('update:modelValue', false)">Cancel</UButton>
                    <UButton color="violet" :loading="submitting" @click="submit">Accept</UButton>
                </div>
            </template>
        </UCard>
    </UModal>
</template>

<script setup lang="ts">
defineProps<{
    modelValue: boolean
    submitting?: boolean
}>()

const emit = defineEmits<{
    (e: 'update:modelValue', value: boolean): void
    (e: 'submit', payload: { remarks: string | null }): void
}>()

const remarks = ref('')

function submit() {
    emit('submit', { remarks: remarks.value.trim() || null })
}
</script>
